const roleMessageIds = {
  ADMIN: 'roleLabelAdmin',
  TDI_CONNECT_ADMIN: 'roleLabelTdiConnectAdmin',
  SUPPORT: 'roleLabelSupport',
  TDI_CONNECT_SUPPORT: 'roleLabelTdiConnectSupport',
  CAAS_ADMIN: 'roleLabelCaasAdmin',
  TDI_CONNECT_CAAS_ADMIN: 'roleLabelTdiConnectCaasAdmin',
  ACCOUNT_OWNER: 'roleLabelAccountOwner',
  TDI_CONNECT_ACCOUNT_OWNER: 'roleLabelTdiConnectAccountOwner',
  ACCOUNT_ASSISTANT: 'roleLabelAccountAssistant',
  TDI_CONNECT_ACCOUNT_ASSISTANT: 'roleLabelTdiConnectAccountAssistant',
  TECHNICAL_LEAD: 'roleLabelTechnicalLead',
  TDI_CONNECT_TECHNICAL_LEAD: 'roleLabelTdiConnectTechnicalLead',
  DEVELOPER: 'roleLabelDeveloper',
  TDI_CONNECT_DEVELOPER: 'roleLabelTdiConnectDeveloper',
};

// Strips TDI_CONNECT_ prefix so both prefixed and unprefixed versions of a role
// are treated as equivalent when checking assignability.
const normalizeRole = (role: string): string => role.replace(/^TDI_CONNECT_/, '');

const isKnownRole = (role: string): role is keyof typeof roleMessageIds =>
  Object.hasOwn(roleMessageIds, role);

// `User.role` is typed as a closed union, but a role value from the API that
// isn't (yet) in `roleMessageIds` - a newly added role, stale data, etc. -
// would otherwise look up as `undefined` and crash `intl.formatMessage`.
const roleMessageId = (role: string): string =>
  isKnownRole(role) ? roleMessageIds[role] : 'roleLabelUnknown';

const assignableRoleMessageIds = (userRoles: string[]): Record<string, string> => {
  const normalizedUserRoles = new Set(userRoles.map(normalizeRole));
  const newLookup: Record<string, string> = {};
  Object.keys(roleMessageIds).forEach(key => {
    if (normalizedUserRoles.has(normalizeRole(key))) {
      newLookup[key] = roleMessageIds[key as keyof typeof roleMessageIds];
    }
  });
  return newLookup;
};

export { roleMessageIds, assignableRoleMessageIds, normalizeRole, roleMessageId };
